import classNames from 'classnames';
import type { StrapiImage } from '@cardo/types';
import { generateImgProps } from '~/lib/strapiImage';

type InfluencerBrandProps = {
  displayName: string;
  image: StrapiImage;
};

export default function InfluencerBrand({
  displayName,
  image,
}: InfluencerBrandProps) {
  return (
    <div className="flex items-center gap-3">
      <div
        className={classNames(
          'flex justify-center items-center rounded-full w-8 h-8 sm:w-14 sm:h-14 overflow-hidden border shadow-md',
          image.data && 'bg-white',
          !image.data && 'bg-theme-blue-darkest'
        )}
      >
        {image.data && (
          <img
            {...generateImgProps(image)}
            className="object-contain"
            alt={`${displayName}'s avatar`}
          />
        )}
      </div>
      <div>
        <h3 className="text-base sm:text-2xl font-extrabold">{displayName}</h3>
      </div>
    </div>
  );
}
